import React, { useContext, useReducer } from 'react';
import { node } from 'prop-types';
import { TCLFormStateContext } from '../context';
import { useTCLFormApi } from './useTCLFormApi';

const initialState = {
  activeStep: {
    index: 0,
    id: '',
    title: '',
  },
  steps: new Set(),
};

const tclFormStateReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'changeActiveStep': {
      const { steps } = state;
      const { index } = payload;
      const nextActiveStep = [...steps][index] || null;

      if (nextActiveStep) {
        return {
          ...state,
          activeStep: nextActiveStep,
        };
      }
      return state;
    }
    default:
      throw new Error();
  }
};

export const TCLFormStateContextProvider = ({ children }) => {
  const { multiStep } = useTCLFormApi();
  const [tclFormState, dispatch] = useReducer(tclFormStateReducer, {
    ...initialState,
    activeStep: multiStep[0] || initialState.activeStep,
    steps: new Set(multiStep),
  });
  const actions = {
    changeActiveStep(index) {
      dispatch({
        type: 'changeActiveStep',
        payload: {
          index,
        },
      });
    },
  };

  return (
    <TCLFormStateContext.Provider value={{ tclFormState, actions }}>
      {children}
    </TCLFormStateContext.Provider>
  );
};

TCLFormStateContextProvider.propTypes = {
  children: node.isRequired,
};

export const useTCLFormState = () => useContext(TCLFormStateContext);
